import React from 'react'
import AppSubmitButtonContainer from '../../../components/AppSubmitButtonContainer'
import AppButton from '../../../components/AppButton'
import AppListItems from '../../../components/AppListItems'
import {scheduledReportListType} from './model'

type ReportListProps = {
  handleGetScheduledReportClick: () => void
  handleExcelUploadBtnClick: () => void
  scheduledReports: scheduledReportListType[]
  isScheduledReportSelected: (report: scheduledReportListType) => boolean
  getScheduledReportStyle: (report: scheduledReportListType) => React.CSSProperties
  handleScheduledReportClick: (report: scheduledReportListType) => void
  reportFetchLoading: boolean
  reportUploadLoading: boolean
}

const ReportList = ({
  handleGetScheduledReportClick,
  handleExcelUploadBtnClick,
  scheduledReports,
  isScheduledReportSelected,
  getScheduledReportStyle,
  handleScheduledReportClick,
  reportFetchLoading,
  reportUploadLoading,
}: ReportListProps) => {
  return (
    <>
      <AppSubmitButtonContainer className='mb-3' style={{justifyContent: 'space-between'}}>
        <AppButton
          label='Get Scheduled Reports'
          onClick={handleGetScheduledReportClick}
          btnSize='sm'
          variant={'primary'}
          loading={reportFetchLoading}
          disabled={reportFetchLoading}
        />
        <AppButton
          label='Upload Scheduled Reports'
          onClick={handleExcelUploadBtnClick}
          btnSize='sm'
          variant={'success'}
          loading={reportUploadLoading}
          disabled={reportUploadLoading}
        />
      </AppSubmitButtonContainer>
      {scheduledReports?.length > 0 ? (
        <AppListItems
          items={scheduledReports}
          keyExtractor={({id}) => id}
          isSelectedItem={isScheduledReportSelected}
          labelExtractor={({label}) => label}
          getStyle={getScheduledReportStyle}
          onClickItem={handleScheduledReportClick}
        />
      ) : (
        <p className='h3 text-center'>No Reports found</p>
      )}
    </>
  )
}

export default ReportList
